export default {
  qflow: {
    title: 'Introduction',
    titleP1_1:`
    Q-Flow is mainly used to assist users in using Longxun's first-principles calculation software
    `,
    titleP1_2:`
    . It has a good graphical interface and combines calculation, data storage, data processing,
    data display and other functions. In conjunction with the cloud platform application
    `,
    titleP1_3:`
    , it can complete a complete set of processes from material modeling to property simulation.
    At present, Q-Flow v1.0 has officially landed on the
    `,
    titleP1_3a: 'Longxun supercomputing cloud platform',
    titleP1_4:`
    in April 2022. Registered users can directly click the Q-Flow icon to open the application
    and carry out scientific research and teaching work in physics, chemistry, biology and other fields.
    `,
    feature1: `
    Q-Flow adopts B/S architecture, in which functions such as calculation parameter setting,
    calculation process setting, and result display are deployed on the browser side,
    and functions such as simulation calculation, data storage, and data processing are deployed on the server side.
    `,
    feature2: `
    Q-Flow is simple, convenient and easy to use. The drag-and-drop components and templates
    allow users to quickly complete the calculation process design. The interactive graphical
    interface makes the calculation parameter settings accurate, reliable and reasonable,
    reducing the user's learning cost and improving the calculation reliability and stability.
    `,
    feature3: `
    The calculation, data processing, and data storage functions in Q-Flow are deployed on
    the server and are completed by PWmat, PWmat top-level modules, job scheduling systems,
    and pre-/post-processing programs. Users do not need to be familiar with the Linux system and operations,
    but can directly access the back-end processed data through the browser to obtain the calculation progress,
    calculation results, and calculation generated files efficiently and in real time.
    `,
    step1: 'Access Q-Flow through the Longxun Cloud Platform',
    step2: 'Upload models to private structure libraries',
    step3: 'Quick View Model',
    step4: 'Create a project',
    step5: 'Create a workflow',
    step6: 'Design Workflow',
    step7: 'Set calculation parameters',
    step8: 'Submit the job to start calculation',
    step9: 'View calculation status',
    step10: 'View calculation results',

    download: 'Related Downloads',
    download1: 'PWmat Download',
    download2: 'Module Download',
    download3: 'Download Manual',
    download4: 'Pseudopotential Download',
    download5: 'Mcloud Manual',

  }
}